exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input,select{border-style:solid}.reviews-scrape-frequency input[type=number]{text-align:center}", ""]);

// exports
